export default __webpack_public_path__ + "static/media/cobra.fcbccbd9.jpg";